import React, { type MouseEvent, useEffect, useState } from 'react';

import { AnimatePresence } from 'framer-motion';

import { copyToClipboard } from '@app/helpers';

import { ReactComponent as ShareIcon } from './share.svg';

import { Toast, Wrapper } from './styles';

export const ShareButton = ({ shareUrl }: { shareUrl: string }) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        event.preventDefault();
        event.stopPropagation();

        copyToClipboard(shareUrl, () => setIsCopied(true));
    };

    useEffect(() => {
        if (isCopied) {
            const timeout = setTimeout(() => {
                setIsCopied(false);
            }, 2000);

            return () => clearTimeout(timeout);
        }
    }, [isCopied]);

    return (
        <Wrapper title="Share Link" onClick={handleClick}>
            <AnimatePresence>
                {isCopied && (
                    <Toast initial={{ opacity: 0, y: 5 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 5 }}>
                        Copied!
                    </Toast>
                )}
            </AnimatePresence>
            <ShareIcon />
        </Wrapper>
    );
};
